// extracted by mini-css-extract-plugin
module.exports = {"component":"video-preview_component__3hdKE"};